package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

val InfoBoxStyle = CssStyle {
    base {
        Modifier
            .height(35.px)
            .maxWidth(100.percent)
            .borderRadius(7.px)
            .cursor(Cursor.Pointer)
            .textAlign(TextAlign.Center)
    }

    Breakpoint.MD {
        Modifier.height(40.px)
    }

    Breakpoint.LG {
        Modifier.height(50.px)
    }
}

val InfoBoxIconStyle = CssStyle {
    base {
        Modifier.size(20.px)
    }
    Breakpoint.MD {
        Modifier.size(25.px)
    }
    Breakpoint.LG {
        Modifier.size(30.px)
    }
}

val InfoBoxTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.SemiBold)
    }
    Breakpoint.MD {
        Modifier.fontSize(16.px)
    }
    Breakpoint.LG {
        Modifier.fontSize(20.px)
    }
}

